import { useEffect } from "react";

/**
 * Custom hook to update the document title on initial render.
 * @param title - The new title for the document.
 */
const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    document.title = `${title} | Influns - Where Your Influence Matters`;
  }, [title]);
};

export default useDocumentTitle;
